<template>
  <div>
    <v-list-item-content class="justify-center mt-4">
      <v-btn-toggle v-model="viewMode" shaped>
        <v-btn>
          <v-icon>mdi-view-grid</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>mdi-view-comfy</v-icon>
        </v-btn>
        <v-btn>
          <v-icon>mdi-view-grid-compact</v-icon>
        </v-btn>
      </v-btn-toggle>
    </v-list-item-content>
    <v-list-item-content class="justify-center">
      <v-slider
          v-if="superLightView"
          v-model="superLightItemSize"
          :max="100"
          :min="25"
          :step="1"
          :label="`${superLightItemSize}px`"
          inverse-label
          ticks
          thumb-label
          class=""
        ></v-slider>
    </v-list-item-content>
    <v-list-item-content class="justify-center">
      <div class="d-inline-flex">
        <v-select
          v-model="sortBuddies"
          :items="sortOptions"
          item-text="display"
          item-value="key"
          :label="$t('buddy.sort.title')"
          style="width: 150px;z-index: 999;"
          chips
        ></v-select>
        <v-btn v-if="!disableDirectionBtn" @click="changeDirection()" class="ml-2 mt-5">
          <v-icon>{{ sortDirectionIcon }}</v-icon>
        </v-btn>
      </div>
    </v-list-item-content>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LocalStorage from 'Store/class/local_storage'
import EmbeddedLocalStorage from '@/api/embedded'

export default {
  name: 'global-options',
  computed: {
    ...mapGetters({
      compactView: 'users/compactView',
      sLightView: 'users/superLightView',
      getSort: 'users/sort',
      sLightSize: 'users/superLightSize'
    }),
    embedded () {
      return EmbeddedLocalStorage.get()
    },
    sortOptions () {
      const data = [
        { key: 'extension', display: this.$t('buddy.sort.byExtension') },
        { key: 'name', display: this.$t('buddy.sort.byName') },
        { key: 'status', display: this.$t('buddy.sort.byStatus') }
      ]
      if (!this.embedded) {
        data.unshift({ key: 'custom', display: this.$t('buddy.sort.custom') })
      }
      return data
    },
    viewMode: {
      get: function () {
        if (this.superLightView === true) {
          return 2
        }
        if (this.cView === false && this.superLightView === false) {
          return 0
        }
        if (this.cView === true && this.superLightView === false) {
          return 1
        }
        return null
      },
      set: function (val) {
        if (val === 0) {
          this.cView = false
          this.superLightView = false
        } else if (val === 1) {
          this.cView = true
          this.superLightView = false
        } else if (val === 2) {
          this.cView = false
          this.superLightView = true
        }
      }
    },
    cView: { // compact view
      get: function () {
        return this.compactView
      },
      set: function (val) {
        this.setCompactView(val)
      }
    },
    superLightView: {
      get: function () {
        return this.sLightView
      },
      set: function (val) {
        this.setSuperLightView(val)
      }
    },
    superLightItemSize: {
      get: function () {
        return this.sLightSize
      },
      set: function (val) {
        this.setSuperLightSize(val)
      }
    },
    sortBuddies: {
      get: function () {
        const sortWithDirection = this.getSort
        if (sortWithDirection.match('_')) {
          return sortWithDirection.split('_')[0]
        }
        return this.getSort
      },
      set: function (val) {
        if (this.sortDirection) {
          val = `${val}_${this.sortDirection}`
        }
        this.setBuddiesSort(val)
      }
    },
    disableDirectionBtn () {
      return this.sortBuddies === 'custom'
    },
    sortDirection () {
      const split = this.getSort?.split('_')
      if (split.length > 1) {
        return this.getSort?.split('_')[1]
      }
      return 'asc'
    },
    sortDirectionIcon () {
      if (this.sortDirection === 'asc') {
        return 'mdi-sort-ascending'
      } else if (this.sortDirection === 'desc') {
        return 'mdi-sort-descending'
      }
      return 'mdi-sort-ascending'
    }
  },
  methods: {
    ...mapActions({
      setCompactView: 'setCompactView',
      setSuperLightView: 'setSuperLightView',
      setSuperLightSize: 'setSuperLightSize',
      setBuddiesSort: 'setBuddiesSort'
    }),

    changeDirection () {
      let sort = this.sortBuddies
      if (this.sortDirection) {
        const newDirection = this.sortDirection === 'asc' ? 'desc' : 'asc'
        sort = `${sort}_${newDirection}`
      }
      this.setBuddiesSort(sort)
    }
  },
  mounted () {
    // enforce super light mode in embedded mode
    // for clearly anywhere custom quick dial
    if (this.embedded) {
      this.cView = false
      this.superLightView = true
      this.sortBuddies = LocalStorage.usersSort() || this.sortBuddies
    } else {
      this.cView = LocalStorage.isUsersCompactViewOn()
      this.superLightView = LocalStorage.isUsersSuperLightViewOn()
      this.superLightItemSize = LocalStorage.usersSuperLightSize() || this.superLightItemSize
      this.sortBuddies = LocalStorage.usersSort() || this.sortBuddies
    }
  }
}
</script>

<style></style>
